export default "__VITE_ASSET__D5v6CC5d__"